import React from "react";

// Components
import Home from "../Home";
import About from "../About/About";
import Skills from "../Skills/Skills";
import Tools from "../Tools/Tools";
import Projects from "../Projects";
import Contact from "../Contact";
import Footer from "../Footer/Footer";
import Samples from "../Samples";

const PageLayout = () => {
  return (
    <React.Fragment>
      <Home />
      <About title="ABOUT ME" />
      <Skills />
      <Tools />
      <Projects />
      <Samples />
      <Contact />
      <Footer />
    </React.Fragment>
  );
};

export default PageLayout;
